import { Dispatch, SetStateAction } from 'react';
import MenuItem from '@mui/material/MenuItem';
import PortsAutocomplete from '../../../../../autocompletewithapi/PortsAutocomplete';
import Customdatepicker from '../../../../../customdatepicker/customdatepicker';
import CustomTextField from '../../../../../CustomTextInput';
import NewCustomSelect from '../../../../../newcustomselect/newcustomselect';
import { SuitUIButton } from '../../../../../SuitUIButton';
import UploadLogo from '../../../common/UploadLogo';
import UploadStamp from '../../../common/UploadStamp';
import { CorporatePartner } from '../../../../../../interfaces/CorporatePartner';
import {
    BillOfLaden,
    BillOfLadenFormErrors
} from '../../../../../../interfaces/BillOfLaden';
import { TransformedItems } from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';
import Housebillofladingfield from '../../../../../../pages/dashboard/tradedocuments/housebilloflading/housebillofladingfield/housebillofladingfield';
import { transports } from '../../../../../../utils/appconstants';

interface BillOfLadenStepOneFormProps {
    updateField: (name: string, value: string | number) => void;
    payload: BillOfLaden;
    corporatePartners: CorporatePartner[];
    loadingCorporatepartners: boolean;
    setShowAddPartner: Dispatch<SetStateAction<boolean>>;
    errors: BillOfLadenFormErrors;
    quoteFields: TransformedItems[];
    updateQuoteField: (
        index: number,
        attributeName: keyof TransformedItems,
        attributeValue: TransformedItems[keyof TransformedItems]
    ) => void;
    removeQuoteField: (index: number) => void;
    addQuoteField: () => void;
    activeStep: number;
    setActiveStep: (step: number) => void;
}

const StepOne = ({
    updateField,
    payload,
    corporatePartners,
    loadingCorporatepartners,
    setShowAddPartner,
    errors,
    quoteFields,
    updateQuoteField,
    removeQuoteField,
    addQuoteField,
    activeStep,
    setActiveStep
}: BillOfLadenStepOneFormProps) => {
    return (
        <div className='w-full flex flex-col gap-4'>
            <UploadLogo {...{ payload, updateField }} />

            <UploadStamp {...{ payload, updateField }} />
            <NewCustomSelect
                hasError={errors?.shipperId.length > 0}
                helperText={
                    errors?.shipperId.length > 0 ? errors?.shipperId : undefined
                }
                selectValue={payload.shipperId}
                required
                selectOptions={
                    corporatePartners as unknown as (
                        | string
                        | Record<string, unknown>
                    )[]
                }
                name={'consigneeId'}
                updateField={(_, value) => {
                    updateField('shipperId', value);
                    updateField(
                        'shipperAddress',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item?.id === value
                        )[0]?.address
                    );

                    updateField(
                        'shipperName',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item?.id === value
                        )[0]?.name
                    );
                    updateField(
                        'shipperAccountNumber',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item?.id === value
                        )[0]?.bankAccountNumber
                    );
                    updateField(
                        'shipperBank',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item?.id === value
                        )[0]?.bankName
                    );
                    updateField(
                        'shipperCountry',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item?.id === value
                        )[0]?.bankCountry
                    );
                    updateField(
                        'shipperSwiftCode',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item?.id === value
                        )[0]?.swiftCode
                    );
                }}
                label={'Consigner/Shipper'}
                selectOptionLabel='name'
                loading={loadingCorporatepartners}
                dropdownRender={() => {
                    return (
                        <div className='px-4 border-t border-appcolorgreyfaint'>
                            <p
                                className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                onClick={() => {
                                    setShowAddPartner(true);
                                }}
                            >
                                + Add a New Partner
                            </p>
                        </div>
                    );
                }}
            />

            <CustomTextField
                error={errors?.shipperAddress.length > 0}
                helperText={
                    errors?.shipperAddress.length > 0
                        ? errors?.shipperAddress
                        : undefined
                }
                value={payload?.shipperAddress}
                required
                id='quotation-documentName'
                label='Consigner/Shipper Address'
                name='shipperAddress'
                onChange={(e) => {
                    updateField('shipperAddress', e.target.value);
                }}
            />

            <CustomTextField
                error={errors?.mtdNumber.length > 0}
                helperText={
                    errors?.mtdNumber.length > 0 ? errors?.mtdNumber : undefined
                }
                required
                id='proformainvoice-mtdNumber'
                label='MTD No'
                name='mtdNumber'
                value={payload?.mtdNumber}
                onChange={(e) => {
                    updateField('mtdNumber', e.target.value);
                }}
            />

            <Customdatepicker
                value={payload?.issuedDate || null}
                id='quotation-issuedDate'
                label='Date of Issue'
                name='issuedDate'
                updateField={updateField}
                error={errors?.issuedDate.length > 0}
                helperText={
                    errors?.issuedDate.length > 0
                        ? errors?.issuedDate
                        : undefined
                }
            />

            <NewCustomSelect
                hasError={errors?.consigneeId.length > 0}
                helperText={
                    errors?.consigneeId.length > 0
                        ? errors?.consigneeId
                        : undefined
                }
                selectValue={payload.consigneeId}
                required
                selectOptions={
                    corporatePartners as unknown as (
                        | string
                        | Record<string, unknown>
                    )[]
                }
                name={'consigneeId'}
                updateField={(_, value) => {
                    updateField('consigneeId', value);
                    updateField(
                        'consigneeAddress',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item?.id === value
                        )[0]?.address
                    );
                    updateField(
                        'consigneeName',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item?.id === value
                        )[0]?.name
                    );
                    updateField(
                        'consigneeAccountNumber',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item?.id === value
                        )[0]?.bankAccountNumber
                    );
                    updateField(
                        'consigneeBank',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item?.id === value
                        )[0]?.bankName
                    );
                    updateField(
                        'consigneeCountry',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item?.id === value
                        )[0]?.bankCountry
                    );
                    updateField(
                        'consigneeSwiftCode',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item?.id === value
                        )[0]?.swiftCode
                    );
                }}
                label={'Consignee'}
                // alternativeValue='shippingLineId'
                selectOptionLabel='name'
                loading={loadingCorporatepartners}
                dropdownRender={() => {
                    return (
                        <div className='px-4 border-t border-appcolorgreyfaint'>
                            <p
                                className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                onClick={() => {
                                    setShowAddPartner(true);
                                }}
                            >
                                + Add a New Partner
                            </p>
                        </div>
                    );
                }}
            />

            <CustomTextField
                error={errors?.consigneeAddress.length > 0}
                helperText={
                    errors?.consigneeAddress.length > 0
                        ? errors?.consigneeAddress
                        : undefined
                }
                value={payload?.consigneeAddress}
                required
                id='quotation-documentName'
                label='Consignee Address'
                name='consigneeAddress'
                onChange={(e) => {
                    updateField('consigneeAddress', e.target.value);
                }}
            />

            <CustomTextField
                error={errors?.placeOfReceipt.length > 0}
                helperText={
                    errors?.placeOfReceipt.length > 0
                        ? errors?.placeOfReceipt
                        : undefined
                }
                required
                id='proformainvoice-placeOfReceipt'
                label='Place of Receipt'
                name='placeOfReceipt'
                value={payload?.placeOfReceipt}
                onChange={(e) => {
                    updateField('placeOfReceipt', e.target.value);
                }}
            />

            <Customdatepicker
                value={
                    payload?.dateOfReceipt !== undefined
                        ? payload?.dateOfReceipt
                        : null
                }
                id='quotation-dateOfReceipt'
                label='Date Of Receipt'
                name='dateOfReceipt'
                updateField={updateField}
                error={errors?.dateOfReceipt.length > 0}
                helperText={
                    errors?.dateOfReceipt.length > 0
                        ? errors?.dateOfReceipt
                        : undefined
                }
            />

            <CustomTextField
                error={errors?.shipmentReferenceNumber.length > 0}
                helperText={
                    errors?.shipmentReferenceNumber.length > 0
                        ? errors?.shipmentReferenceNumber
                        : undefined
                }
                required
                id='proformainvoice-shipmentReferenceNumber'
                label='Shipment Reference Number'
                name='shipmentReferenceNumber'
                value={payload?.shipmentReferenceNumber}
                onChange={(e) => {
                    updateField('shipmentReferenceNumber', e.target.value);
                }}
            />

            <NewCustomSelect
                hasError={errors?.notifyPartyId.length > 0}
                helperText={
                    errors?.notifyPartyId.length > 0
                        ? errors?.notifyPartyId
                        : undefined
                }
                selectValue={payload.notifyPartyId}
                required
                selectOptions={
                    corporatePartners as unknown as (
                        | string
                        | Record<string, unknown>
                    )[]
                }
                name={'notifyPartyId'}
                updateField={(_, value) => {
                    updateField('notifyPartyId', value);
                    updateField(
                        'notifyPartyName',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item?.id === value
                        )[0]?.name
                    );
                }}
                label={'Notify Party'}
                // alternativeValue='shippingLineId'
                selectOptionLabel='name'
                loading={loadingCorporatepartners}
                dropdownRender={() => {
                    return (
                        <div className='px-4 border-t border-appcolorgreyfaint'>
                            <p
                                className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                onClick={() => {
                                    setShowAddPartner(true);
                                }}
                            >
                                + Add a New Partner
                            </p>
                        </div>
                    );
                }}
            />

            <PortsAutocomplete
                errorCondition={errors?.portOfLoadingId.length > 0}
                helperText={
                    errors?.portOfLoadingId.length > 0
                        ? errors?.portOfLoadingId
                        : undefined
                }
                id='quotation-portOfLoading'
                label='Port of Loading'
                name='portOfLoadingId'
                updateField={updateField}
                nameValue='portOfLoadingValue'
                value={payload.portOfLoadingValue}
            />

            <PortsAutocomplete
                errorCondition={errors?.portOfDischargeId.length > 0}
                helperText={
                    errors?.portOfDischargeId.length > 0
                        ? errors?.portOfDischargeId
                        : undefined
                }
                id='quotation-portOfDischarge'
                label='Port of Discharge'
                name='portOfDischargeId'
                updateField={updateField}
                nameValue='portOfDischargeValue'
                value={payload.portOfDischargeValue}
            />

            <CustomTextField
                error={errors?.vesselAndVoyage.length > 0}
                helperText={
                    errors?.vesselAndVoyage.length > 0
                        ? errors?.vesselAndVoyage
                        : undefined
                }
                required
                id='proformainvoice-vesselAndVoyage'
                label='Vessel and Voyage'
                name='vesselAndVoyage'
                value={payload?.vesselAndVoyage}
                onChange={(e) => {
                    updateField('vesselAndVoyage', e.target.value);
                }}
            />
            <div className='border border-gray300 border-dashed mt-4 lg:mt-0 lg:border-none' />
            <Customdatepicker
                value={
                    payload?.startDateOfDelivery !== undefined
                        ? payload?.startDateOfDelivery
                        : null
                }
                id='quotation-startDateOfDelivery'
                label='Start Date Of Delivery'
                name='startDateOfDelivery'
                updateField={updateField}
                error={errors?.startDateOfDelivery.length > 0}
                helperText={
                    errors?.startDateOfDelivery.length > 0
                        ? errors?.startDateOfDelivery
                        : undefined
                }
            />

            <Customdatepicker
                value={
                    payload?.endDateOfDelivery !== undefined
                        ? payload?.endDateOfDelivery
                        : null
                }
                id='quotation-endDateOfDelivery'
                label='End Date Of Delivery'
                name='endDateOfDelivery'
                updateField={updateField}
                error={errors?.endDateOfDelivery.length > 0}
                helperText={
                    errors?.endDateOfDelivery.length > 0
                        ? errors?.endDateOfDelivery
                        : undefined
                }
            />

            <CustomTextField
                error={errors?.placeOfDelivery.length > 0}
                helperText={
                    errors?.placeOfDelivery.length > 0
                        ? errors?.placeOfDelivery
                        : undefined
                }
                required
                id='commercialinvoice-placeOfDelivery'
                label='Place of Delivery'
                name='placeOfDelivery'
                value={payload?.placeOfDelivery}
                onChange={(e) => {
                    updateField('placeOfDelivery', e.target.value);
                }}
            />

            <CustomTextField
                select
                error={errors?.transport.length > 0}
                helperText={
                    errors?.transport.length > 0 ? errors?.transport : undefined
                }
                required
                id='commercialinvoice-transport'
                label='Transport'
                value={payload.transport}
                name='transport'
                onChange={(e) => {
                    updateField('transport', e.target.value);
                }}
            >
                {transports.map((item, index) => (
                    <MenuItem value={item} key={`transports-${item}-${index}`}>
                        {item}
                    </MenuItem>
                ))}
            </CustomTextField>

            <CustomTextField
                error={errors?.placeOfTranshipment.length > 0}
                helperText={
                    errors?.placeOfTranshipment.length > 0
                        ? errors?.placeOfTranshipment
                        : undefined
                }
                required
                id='commercialinvoice-placeOfTranshipment'
                label='Route / place of Transhipment'
                value={payload.placeOfTranshipment}
                name='placeOfTranshipment'
                onChange={(e) => {
                    updateField('placeOfTranshipment', e.target.value);
                }}
            />
            <CustomTextField
                error={errors?.billOfLadingNumber.length > 0}
                helperText={
                    errors?.billOfLadingNumber?.length > 0
                        ? errors?.billOfLadingNumber
                        : undefined
                }
                value={payload?.billOfLadingNumber}
                required
                id='quotation-billOfLadingNumber'
                label='Bill of Lading Number'
                name='billOfLadingNumber'
                onChange={(e) => {
                    updateField('billOfLadingNumber', e.target.value);
                }}
            />

            <CustomTextField
                error={errors?.salesContractNumber?.length > 0}
                helperText={
                    errors?.salesContractNumber?.length > 0
                        ? errors?.salesContractNumber
                        : undefined
                }
                value={payload?.salesContractNumber}
                required
                id='quotation-salesContractNumber'
                label='Sales Contract Number'
                name='salesContractNumber'
                onChange={(e) => {
                    updateField('salesContractNumber', e.target.value);
                }}
            />
            {quoteFields.map((item, index) => (
                <Housebillofladingfield
                    key={item.id}
                    index={index}
                    id={item.id ?? ''}
                    updateQuoteField={updateQuoteField}
                    removeQuoteField={removeQuoteField}
                    item={item}
                />
            ))}

            <SuitUIButton
                text='Add field'
                onClick={addQuoteField}
                invert
                style='px-[0.92rem] border border-gray300 text-steelBlue font-medium text-sm leading-[20px] lg:border-none lg:text-appcolorprimary'
            />
        </div>
    );
};

export default StepOne;
